if (window.location.pathname === "/acondicionamiento") {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#tablaAcondicionamiento tbody");
    const filtroMes = document.getElementById("filtroMes");
    const filtroAño = document.getElementById("filtroAño");

    if (tableBody && filtroMes && filtroAño) {

        let cargando = false;
        let timeoutFiltro = null;

        function formatearNumero(numero) {
            if (numero === null || numero === undefined || isNaN(numero)) return 0;
            return Number(numero).toLocaleString("en-US");
        }

        async function actualizarTabla() {
            if (cargando) return;
            if (document.hidden) return;

            cargando = true;

            const mes = filtroMes.value;
            const anio = filtroAño.value;

            const url = `/api/acondicionamiento?filtroMes=${mes}&filtroAnio=${anio}`;

            try {
                const response = await fetch(url, requestOptions);

                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                const result = await response.json();
                const data = result.result;

                tableBody.innerHTML = "";

                if (!data || !data.resultado || data.resultado.length === 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data");

                    row.innerHTML = `
                        <td colspan="12">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    `;

                    tableBody.appendChild(row);
                    return;
                }

                data.resultado.forEach(function (item) {
                    const row = document.createElement("tr");

                    row.innerHTML = `
                        <td><a href="acondicionamiento/periodo?mes=${item.mesPeriodo}&año=${item.anioPeriodo}">${item.periodo}</a></td>
                        <td>${formatearNumero(item.totalTrabajos)}</td>
                        <td>${formatearNumero(item.totalOf)}</td>
                        <td>${formatearNumero(item.totalUnidadesRequeridas)}</td>
                        <td>${formatearNumero(item.totalUnidadesBuenas)}</td>
                        <td>${formatearNumero(item.totalOtraDisposicion)}</td>
                        <td>${formatearNumero(item.totalUnidadesMalas)}</td>
                        <td>${formatearNumero(item.porcentajeCumplimiento)}%</td>
                        <td>${formatearNumero(item.porcentajeBuenas)}%</td>
                        <td>${formatearNumero(item.porcentajeMalas)}%</td>
                        <td>${formatearNumero(item.operariosParticipantes)}</td>
                    `;

                    tableBody.appendChild(row);
                });

            } catch (error) {
                console.error("Error en tabla acondicionamiento:", error);

                if (typeof lanzarAlerta === "function") {
                    lanzarAlerta("No se pudo actualizar la tabla de acondicionamiento.", "alerta-roja");
                }

            } finally {
                cargando = false;
            }
        }

        function actualizarConDebounce() {
            clearTimeout(timeoutFiltro);

            timeoutFiltro = setTimeout(function () {
                actualizarTabla();
            }, 200);
        }

        filtroMes.addEventListener("input", actualizarConDebounce);
        filtroAño.addEventListener("input", actualizarConDebounce);

        actualizarTabla();

        setInterval(function () {
            actualizarTabla();
        }, 120000);
    }
}
